import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { autenticacionGuard } from './compartido/autenticacion/autenticacion.guards';
import { autorizacionGuard } from './compartido/autorizacion/autorizacion.guards';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./interior/interior.module').then((m) => m.InteriorModule),
    canActivate: [autenticacionGuard],
    canActivateChild: [autenticacionGuard, autorizacionGuard],
  },
  {
    path: '',
    loadChildren: () => import('./exterior/exterior.module').then((m) => m.ExteriorModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
